export default __webpack_public_path__ + "static/media/download-icon.f385ba48.gif";